
<p-menubar [model]="items">
  <img src="../../assets/equator.png" alt="">
</p-menubar>
